import { Select, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";

/**
 * Селектор «Стадия» для отчёта «Заказ поставщику».
 * Значения тянутся при загрузке страницы через pageStore.getAllOrderSupplierStages().
 */
const SelectStage = observer(() => {
  const { pageStore } = useStores();

  return (
    <VStack>
      <Select
        style={{
          border: "none",
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
          fontSize: "14px",
        }}
        placeholder="Все стадии"
        width="220px"
        value={pageStore.os_stage_filter || ""}
        onChange={(e) => pageStore.setOsStageFilter(e.target.value || "")}
      >
        {pageStore.all_order_supplier_stages.map((item, idx) => (
          <option
            style={{ background: "#0C0C0C", color: "#EEEEEE" }}
            value={item?.value}
            key={idx}
          >
            {item?.value}
          </option>
        ))}
      </Select>
    </VStack>
  );
});

export default SelectStage;
